var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app", attrs: { id: "app" }, on: { mousemove: _vm.move } },
    [
      _vm.dev
        ? _c(
            "button",
            { staticClass: "dbgbot", on: { click: _vm.generate_atlas } },
            [_vm._v("Generate Atlas")]
          )
        : _vm._e(),
      _c(
        "svg",
        {
          ref: "svg",
          staticClass: "atlas_svg",
          attrs: { xmlns: "http://www.w3.org/2000/svg", version: "1.1" }
        },
        [
          _c(
            "filter",
            { attrs: { id: "grayscale" } },
            [
              _c("feColorMatrix", {
                attrs: {
                  type: "matrix",
                  values:
                    "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0"
                }
              })
            ],
            1
          ),
          _c("g", { ref: "wrapper" }, [
            _c("g", { attrs: { id: "bg", fill: "none" } }, [
              _c("image", {
                attrs: {
                  "xlink:href": _vm.atlas_image,
                  x: "0",
                  y: "0",
                  width: "177",
                  height: "100"
                }
              })
            ]),
            _c(
              "g",
              { attrs: { fill: "none" } },
              _vm._l(_vm.sextants, function(s) {
                return _c("sextant", {
                  key: s.id,
                  ref: _vm.ref("sext", s.id),
                  refInFor: true,
                  attrs: { sextant: s, pos: _vm.positions[s.id] }
                })
              })
            ),
            _c(
              "g",
              { ref: "maps", attrs: { fill: "none" } },
              _vm._l(_vm.maps, function(m) {
                return _c("atlas-map", {
                  key: m.id,
                  ref: _vm.ref("map", m.id),
                  refInFor: true,
                  attrs: { map: m, pos: _vm.positions[m.id] }
                })
              })
            )
          ])
        ]
      ),
      _c("search"),
      _c("sextants-menu", {
        ref: "menu",
        attrs: { maps: _vm.maps, sextants: _vm.sextants }
      }),
      _c("my-footer"),
      _c("help-modal", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.show_help,
            expression: "show_help"
          }
        ],
        ref: "help_modal",
        on: {
          close_modal: function($event) {
            _vm.show_help = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 65
// module chunks = 0